export const SORT_PRODUCT_REVIEWS_BY = {
  date_asc: 'DATE_ASC',
  date_desc: 'DATE_DESC',
  rate_asc: 'RATE_ASC',
  rate_desc: 'RATE_DESC',
};
